<script>
export function iOS() {
    try {
        return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.userAgentData.platform)  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    } catch {
        return navigator.userAgent.includes("iPad") || navigator.userAgent.includes("iPhone") || navigator.userAgent.includes("iPod") || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
  
  // iPad on iOS 13 detection
 
}


let skip
let HEARTBEAT_TIMER
let SESSION_DATA = {
    events: [],
    tenant: ""
}

function ensureClientSessionId() {
  try {
    const key = 'mgc_client_session_id'
    let id = sessionStorage.getItem(key)
    if (!id) {
      if (window.crypto && window.crypto.randomUUID) {
        id = window.crypto.randomUUID()
      } else {
        id = Math.random().toString(36).slice(2) + Date.now().toString(36)
      }
      sessionStorage.setItem(key, id)
    }
    return id
  } catch {
    // Fallback if sessionStorage not available
    return Math.random().toString(36).slice(2) + Date.now().toString(36)
  }
}

async function sendLivePing() {
  try {
    const token = localStorage.getItem('token') || ''
    const base = process.env.VUE_APP_ANALYTICS_API_BASE_URL || ''
    const url = base + '/live/ping'
    const payload = {
      universitySlug: SESSION_DATA.universitySlug,
      page: (window && window.location && window.location.pathname) || '/',
      clientSessionId: ensureClientSessionId(),
    }
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
      keepalive: true,
    })
  } catch (e) {
    // Swallow errors; live pings are best-effort
  }
}

export const trackEvent = (name, properties) => {
    SESSION_DATA.events.push({
        event: name,
        timestamp: new Date().getTime(),
        ...properties
    })
    console.log({
        event: name,
        timestamp: new Date().getTime(),
        ...properties
    })
}

export const startSession = (tenant, router, properties = {}) => {
    console.log(router)
    trackEvent(router.path, {
        label : "PAGE",
    })
    console.log(properties)
    SESSION_DATA.tenant = tenant
    SESSION_DATA = {...SESSION_DATA, ...properties}
    // kick off live heartbeats
    try {
      if (HEARTBEAT_TIMER) clearInterval(HEARTBEAT_TIMER)
      sendLivePing()
      HEARTBEAT_TIMER = setInterval(sendLivePing, 10000)
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          sendLivePing()
        }
      })
    } catch (e) { void 0 }
}

// call this function on exit
export const endSession = () => {
  // skip if the function has already been called
  if (skip) return
  skip = true
  if (HEARTBEAT_TIMER) {
    try { clearInterval(HEARTBEAT_TIMER) } catch (e) { HEARTBEAT_TIMER = null }
    HEARTBEAT_TIMER = null
  }
  trackEvent("end session", {label: "END"})
  // I also add an "end session" event to the data here
  const data = SESSION_DATA
  // include clientSessionId so we can correlate live presence if needed
  try { data.clientSessionId = ensureClientSessionId() } catch (e) { void 0 }
  const payload = JSON.stringify(data)
  const url = process.env.VUE_APP_ANALYTICS_BASE_URL + "metrics"
  const { vendor } = window.navigator

  // https://bugs.webkit.org/show_bug.cgi?id=188329
  // Safari bug is fixed but not yet released. When that happens, will need to check safari version also
  if (window.navigator.sendBeacon && !~vendor.indexOf("Apple")) {
    // try to send the beacon
    try {
      const beacon = window.navigator.sendBeacon(url, payload)
      if (beacon) return
    } catch (e) {
      // ignore errors and fall back to other methods
    }
    // if it failed to queue, (some adblockers will block all beacons), then try the other way
  }

  // Use fetch with keepalive when possible
  const async = !iOS()
  if (window.fetch && async) {
    try {
      window.fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true,
      })
      return
    } catch (e) {
      // ignore errors and fall back to XHR
    }
  }

  // Fallback to XMLHttpRequest
  const request = new XMLHttpRequest()
  request.open("POST", url, async) // 'false' makes the request synchronous
  request.setRequestHeader("Content-Type", "application/json")
  request.send(payload)

  // Synchronous request cause a slight delay in UX as the browser waits for the response
  // I've found it more performant to do an async call and use the following hack to keep the loop open while waiting

  // Chrome doesn't care about waiting
  if (!async || ~vendor.indexOf('Google')) return

  // Latency calculated from navigator.performance
  const latency = data.latency || 0
  const t = Date.now() + Math.max(300, latency + 200)
  while (Date.now() < t) {
    // postpone the JS loop for 300ms so that the request can complete
    // a hack necessary for Firefox and Safari refresh / back button
  }
}

export default {
  name: "Analytics",
  components: {},
};
</script>
